export default __webpack_public_path__ + "static/media/sensitivity-var.fd09225f.svg";